import { EffectsCommandMap } from 'dva';
import type { ChangeAction, OnMountPageAction, OnUnmountPageAction, FetchInfoAction, Fetch_CollectionItems_Action } from './types';
import { initStates } from './initialState';

export const pageEffects = {
  *onMountPage(
    { payload }: OnMountPageAction,
    { put }: EffectsCommandMap,
  ) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        exhibit_ID: payload.exhibitID,
      },
    });

    yield put<FetchInfoAction>({
      type: 'fetchInfo',
    });
  },
  *onUnmountPage({}: OnUnmountPageAction, { put }: EffectsCommandMap) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        ...initStates,
      },
    });
  },
};
